export let GlobalVariables = {
	devMode: null,
	isMobile: null,
	resizeCallbacks: [],
	mobileResizeCallbacks: [],
	lenis: null
};
